export type BRAINTREE_TOKEN_SUCCESS = "payments.BRAINTREE_TOKEN_SUCCESS";
export const BRAINTREE_TOKEN_SUCCESS: BRAINTREE_TOKEN_SUCCESS =
  "payments.BRAINTREE_TOKEN_SUCCESS";
